export const OPEN_MODAL = 'containers/ErrorMessageModal/OPEN_MODAL';
export const CLOSE_MODAL = 'containers/ErrorMessageModal/CLOSE_MODAL';
